import type { SetupContext } from "vue";
import { type DefaultSelectorProps, DefaultSelectorEmits } from "./index";

import type { UiTypes } from "various-ui";

export const useComposable = (define: DefaultSelectorProps, emit: SetupContext<typeof DefaultSelectorEmits>["emit"]) => {
    //* 函数列表
    const methods = {
        //* 点击事件
        click: (value: string) => {
            emit("update:modelValue", value);
            emit("change", define.modelValue);
        },

        //* 获取类名
        receiveName: (data: UiTypes.candidate) => {
            return {
                active: data.value == define.modelValue,
                disabled: define.disabled.includes(data.value),
            };
        },
    };

    //* 计算属性
    const computeds = {
        className: computed(() => {
            return `${define.size}-selector-size`;
        }),
    };

    return { methods, computeds };
};
